export default __webpack_public_path__ + "images/CP.8136bce.png";